import React, {Component, } from 'react';
import { EDITOR_DESKTOP_LEFT_BAR_MENU_ID, EDITOR_DESKTOP_LEFT_BAR_MENU_ELEMENTS_ID } from 'crazyEditor/core/constants/editorConstants';
import { connect } from 'react-redux';
import CustomMenuElementDraggableLayer from './MenuElement/CustomMenuElementDraggableLayer';
import styles from './TwoLevelesMenuStyle';
import platform from 'platform';
import SecondLevelMenu from './SecondLevelMenu/SecondLevelMenu';
import { puzzle } from 'shared/icons';
import {toggleLeftMenuSelectedItem} from 'crazyEditor/redux/modules/panel/panel';
import _ from 'lodash';
import {note, text, shapePlus} from 'shared/icons/index';
import TopLevelMenuElement from './TopLevelMenuElement/TopLevelMenuElement';
import {getMenuElementsTree} from './MenuElementsTree';
import {getNormalizedTemplateTagSpecifics} from 'crazyEditor/redux/modules/templateTagSet/templateTagSelectors';
import transitions from 'material-ui/styles/transitions';
const classes = require('./DesktopEditorLeftBar.scss');

import {TOP_LEVEL_MENU_HEIGHT} from './TwoLevelesMenuStyle';
import { setSelectedElementIds } from 'crazyEditor/redux/modules/stage/stage';

const renderDragLayer = !(platform.name === 'IE' || platform.name === 'Microsoft Edge');

@connect(
  state => ({
    isResizingElement: state.stage.isResizingElement,
    isDraggingElement: state.stage.isDraggingElement,
    stageLayoutTop: state.stage.layout.top,
    leftMenuSelectedItem: state.panel.leftMenuSelectedItem,
    templateTagSpecifics: getNormalizedTemplateTagSpecifics(state), // templateTagSpecifics is used in building the tree
  }),
  {toggleLeftMenuSelectedItem, setSelectedElementIds} // setSelectedElementIds is used in building the tree
)
export default class DesktopEditorLeftBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuElements: getMenuElementsTree(props),
    };
  }

  componentWillReceiveProps(nextProps) {
    const {leftMenuSelectedItem} = nextProps;
    if (leftMenuSelectedItem !== null && leftMenuSelectedItem !== this.props.leftMenuSelectedItem) {
      const {menuElements} = this.state;
      this.lastLeftMenuSelectedItemIndex = _.keys(menuElements).indexOf(leftMenuSelectedItem);
      this.renderSecondLevelMenu = true;
    }
    if (this.props.leftMenuSelectedItem === null && leftMenuSelectedItem !== null) {
      this.animateOpacityOnly = true;
    } else {
      this.animateOpacityOnly = false;
    }
  }

  handleSecondLevelMenuRequestClose = () => {
    const {toggleLeftMenuSelectedItem} = this.props;
    toggleLeftMenuSelectedItem(null);
  };

  toggleSelectedMenu(newSelectedTopMenu) {
    const {toggleLeftMenuSelectedItem} = this.props;
    toggleLeftMenuSelectedItem(newSelectedTopMenu);
  }

  render() {
    const {menuElements} = this.state;
    const { leftMenuSelectedItem, isResizingElement, isDraggingElement, stageLayoutTop } = this.props;
    const isAnyItemSelected = leftMenuSelectedItem !== null;
    const {lastLeftMenuSelectedItemIndex, animateOpacityOnly} = this;
    const transition = transitions.easeOut('300ms', animateOpacityOnly ? 'opacity' : 'all');
    return (
      <div style={{...styles.container, top: stageLayoutTop}} className={[classes.enterFromLeft, classes.leftMenu].join(' ')}>
        <div key="mainMenu" id={EDITOR_DESKTOP_LEFT_BAR_MENU_ID}
                    style={_.merge({}, styles.firstLevelMenuContainer, (isResizingElement || isDraggingElement) && {pointerEvents: 'none'})}
        >
          <div id={EDITOR_DESKTOP_LEFT_BAR_MENU_ELEMENTS_ID} style={{position: 'relative', marginTop: 20}}>
            <div style={{zIndex: 1}}>
              {
                _.map(menuElements, (menuElement, index) => {
                  const {nestedMenuElements, ...props} = menuElement;
                  return (
                    <TopLevelMenuElement
                      key={index}
                      selected = {platform.name === 'IE' && index === leftMenuSelectedItem}
                      {...props}
                      onClick={this.toggleSelectedMenu.bind(this, index)}
                    />
                  );
                })
              }
            </div>
            {
              // this is an overlay white layer to animate the selection transition
              platform.name !== 'IE' &&
              <div style={{zIndex: 2, transition: transition, opacity: isAnyItemSelected ? 1 : 0, pointerEvents: 'none', position: 'absolute', left: 0, top: 0, transform: `translateY(${TOP_LEVEL_MENU_HEIGHT * lastLeftMenuSelectedItemIndex}px)`, overflow: 'hidden', height: TOP_LEVEL_MENU_HEIGHT}}>
                <div style={{transform: `translateY(-${TOP_LEVEL_MENU_HEIGHT * lastLeftMenuSelectedItemIndex}px)`, transition: transition}}>
                  {
                    _.map(menuElements, (menuElement, index) => {
                      const {nestedMenuElements, ...props} = menuElement;
                      return (
                        <TopLevelMenuElement
                          key={index}
                          selected
                          {...props}
                        />
                      );
                    })
                  }
                </div>
              </div>
            }
          </div>
        </div>
        {
          renderDragLayer &&
          <CustomMenuElementDraggableLayer/>
        }
        {
          this.renderSecondLevelMenu &&
          <SecondLevelMenu
            elements = {_.get(menuElements[leftMenuSelectedItem], 'nestedMenuElements')}
            open={isAnyItemSelected}
            leftMenuSelectedItemIndex = {lastLeftMenuSelectedItemIndex}
            onRequestClose = {this.handleSecondLevelMenuRequestClose}
          />
        }
      </div>
    );
  }
}

